import { render, staticRenderFns } from "./Aprovados.vue?vue&type=template&id=3ae5ba32&"
import script from "./Aprovados.vue?vue&type=script&lang=js&"
export * from "./Aprovados.vue?vue&type=script&lang=js&"
import style0 from "./Aprovados.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports